export interface SupportedLanguageInfo {
  code: string;
  native: string;
  flag: string;
  /** Código de 3 letras usado en el menú visual (no es el código ISO usado por i18next). */
  displayCode: string;
}

// El código 'pt' de la app es portugués de Portugal (pt-PT), no de Brasil (pt-BR).
// Ver locales/pt.ts y locales/recognition/pt.ts, y la nota en Azure Translator (api/client.ts).
export const SUPPORTED_LANGUAGES: SupportedLanguageInfo[] = [
  { code: 'es', native: 'Español',    flag: '🇲🇽', displayCode: 'ESP' },
  { code: 'en', native: 'English',    flag: '🇺🇸', displayCode: 'ENG' },
  { code: 'fr', native: 'Français',   flag: '🇫🇷', displayCode: 'FRA' },
  { code: 'nl', native: 'Nederlands', flag: '🇳🇱', displayCode: 'NLD' },
  { code: 'de', native: 'Deutsch',    flag: '🇩🇪', displayCode: 'DEU' },
  { code: 'pt', native: 'Português',  flag: '🇵🇹', displayCode: 'POR' },
  { code: 'ro', native: 'Română',     flag: '🇷🇴', displayCode: 'ROM' },
];

export const SUPPORTED_LANGUAGE_CODES: string[] = SUPPORTED_LANGUAGES.map(lang => lang.code);
